export default __webpack_public_path__ + "static/media/chat.c76905e8.jpg";